import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

import {
    FormatDate
} from '../../../../../libraries/Tool';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="fxgetcurrentdate">
                1.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxgetcurrentdate')}
            </Typography>
            <p><strong>{translate('fxgetcurrentdate')}</strong> システムカレンダーに従って現在の日付を返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('utcoffset')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>現地時間と UTC タイムスタンプ間の時間差</td>
                                <td>7</td>
                            </tr>
                            <tr>
                                <td>{translate('format')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>返される結果の形式</td>
                                <td>"YYYY-MM-DD"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. GetCurrentDate(7 , "YYYY-MM-DD") returns { FormatDate(new Date(), "yyyy-MM-dd") }</div>
                    <div>2. GetCurrentDate(7 , "YYYY-MM") returns { FormatDate(new Date(), "yyyy-MM") }</div>
                    <div>3. GetCurrentDate(7 , "YYYY") returns { FormatDate(new Date(), "yyyy") }</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxgetcurrenttime">
                2.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxgetcurrenttime')}
            </Typography>
            <p><strong>{translate('fxgetcurrenttime')}</strong> システムカレンダーに従って現在時刻を返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('utcoffset')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>現地時間と UTC タイムスタンプ間の時間差</td>
                                <td>7</td>
                            </tr>
                            <tr>
                                <td>{translate('format')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>返される結果の形式</td>
                                <td>"HH:mm:ss"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. GetCurrentTime(7 , "HH:mm:ss") returns { FormatDate(new Date(), "HH:mm:ss") }</div>
                    <div>2. GetCurrentTime(7 , "HH:mm") returns { FormatDate(new Date(), "HH:mm") }</div>
                    <div>3. GetCurrentTime(7 , "HH") returns { FormatDate(new Date(), "HH") }</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxgetcurrenttimestamp">
                3.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxgetcurrenttimestamp')}
            </Typography>
            <p><strong>{translate('fxgetcurrenttimestamp')}</strong> システムカレンダーに従って現在の日付と時刻を返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('utcoffset')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>現地時間と UTC タイムスタンプ間の時間差</td>
                                <td>7</td>
                            </tr>
                            <tr>
                                <td>{translate('format')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>返される結果の形式</td>
                                <td>"YYYY-MM-DD HH:mm:ss"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. GetCurrentTimestamp(7 , "YYYY-MM-DD HH:mm:ss") returns { FormatDate(new Date(), "yyyy-MM-dd HH:mm:ss") }</div>
                    <div>2. GetCurrentTimestamp(7 , "YYYY-MM-DD HH:mm") returns { FormatDate(new Date(), "yyyy-MM-dd HH:mm") }</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxgetfilesizeiniytes">
                4.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxgetfilesizeiniytes')}
            </Typography>
            <p><strong>{translate('fxgetfilesizeiniytes')}</strong> ファイルのサイズを返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>ファイルのパス</td>
                                <td>"/tmp/filename.txt"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. GetFilesizeInBytes("/tmp/log.txt") returns 13726</div>
                    <div>2. GetFilesizeInBytes("/tmp/sample.pdf") returns 38765</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxgetnumberoffiles">
                5.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxgetnumberoffiles')}
            </Typography>
            <p><strong>{translate('fxgetnumberoffiles')}</strong> ディレクトリ内に存在するファイルの数を返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('directory')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>ディレクトリのパス</td>
                                <td>"/tmp/directory"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. GetNumberOfFiles("/tmp/document") returns 3</div>
                    <div>2. GetNumberOfFiles("/tmp/download") returns 0</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxgetscriptparameter">
                6.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxgetscriptparameter')}
            </Typography>
            <p><strong>{translate('fxgetscriptparameter')}</strong> ステップから現在のスクリプトに渡されたスクリプトパラメータを返します。 <strong>{translate('runrobot')}</strong>.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>

                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="any" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. GetScriptParameter() ステップから現在のスクリプトに渡されたスクリプトパラメータを返します。 <strong>{translate('runrobot')}</strong></div>
                </div>
            </ul>
        </Box>
    );
}
export default withTranslate(En);